import PlaceSearch from '../components/PlaceSearch';
import { createGMapPlaceholder } from '../cookies-manager/placeholders';

const $elements = document.querySelectorAll('.js-place-search');

if ($elements.length) {
  [...$elements].forEach(($element) => {
    const $tabableElements = $element.querySelectorAll('input, button, a');
    const search = new PlaceSearch($element, {
      onNewCoordinates: () => {
        $element.submit();
      },
    });

    // Cookie management
    const $placeholder = createGMapPlaceholder();

    function waitForCookieConsent() {
      if (search.isMounted) {
        search.unmount();
      }

      $tabableElements.forEach(($tabElement) => {
        $tabElement.setAttribute('tabindex', -1);
      });

      $element.append($placeholder);
    }

    function showForm() {
      if (!search.isMounted) {
        search.mount();
      }

      $tabableElements.forEach(($tabElement) => {
        $tabElement.removeAttribute('tabindex');
      });

      $placeholder.remove();
    }

    waitForCookieConsent();

    document.addEventListener('cookies:updateChoice', (e) => {
      if (e.detail.gmaps) {
        showForm();
      } else {
        waitForCookieConsent();
      }
    });
  });
}
